import React, { useEffect, useRef, useState } from 'react';

import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Sidebar from '../../components/Sidebar/Sidebar';
import mailicon from '../../../assets/img/email-icon.svg';
import googleicon from '../../../assets/img/google-icon.svg';
import appleicon from '../../../assets/img/appleLogo.png';
import cleverIcon from '../../../assets/img/Clever-icon.png';
import classlinkIcon from '../../../assets/img/classlink-icon.png'
import schoolIcon from '../../../assets/img/school-icon.svg'

import '../../scss/Form.scss';
import Select from 'react-select';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  CircularProgress,
  FormControl,
  Radio,
  RadioGroup,
} from '@mui/material';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  calenderYears,
  daysOfMonth,
  monthsOfYear,
} from '../../constants/DropDownConstants';
import validator from 'validator';
import { isValidDate } from '../../../../../../shared/functions/signUp';
import { calculateAge } from '../../../../../../shared/functions/signUp';
import sendCoppaEmail from '../../../../../../shared/Utils/AutenticationApi/sendEmail';
import cookiePreferences from '../../../../../../shared/Utils/CookiePreferenceApi/api';
import { cookiePreferencesWebsite } from '../../../../../../shared/Utils/CookiePreferenceApi/api';
import { environment } from '../../../environments/environment';

import {
  EmailAuthProvider,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  linkWithCredential,
  sendEmailVerification,
  signInWithCredential,
  updateProfile,
  signInWithPopup,
  onAuthStateChanged,
  linkWithPopup,
  OAuthProvider,
  signInWithCustomToken,
  getAuth,
  browserSessionPersistence,
  setPersistence
} from 'firebase/auth';
import { firebaseUserType } from '../../types/types';
import { authen, provider, providerApple } from '../../firebase/firebase';
import { fetchCookieUsers } from '../../Utils/firebase-services';
import CookiesModal from '../../components/Cookies/CookiesModal';
import CookiePolicyModal from '../../components/Cookies/CookiePolicyModal';
import AlertPopup from '../../components/Alert/AlertPopup';
import CustomModal from '../../components/CustomModal';
import CustomNoResponseModal from '../../components/CustomNoResponseModal';
import RemoteErrorLog from '../../Utils/api';
import { Helmet } from 'react-helmet';
import updateUserProfile from 'shared/Utils/UpdateProfileApi/Api';
import DocumentViewerModal from '../../components/DocumentViewerModal';
import { getDownloadURL, listAll, ref } from 'firebase/storage';
import { storage } from '../../firebase/firebase';

export default function SignUpSub({ isSubComponent = false }: { isSubComponent?: boolean }) {
  const { state } = useLocation();

  const [email, setEmail] = useState<string>('');
  const [createPassword, setCreatePassword] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [month, setMonth] = useState<any>(0);
  const [day, setDay] = useState<any>(0);
  const [year, setYear] = useState<any>(0);
  const [userDob, setUserDob] = useState<string>('');

  const [validateDate, setValidateDate] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [age, setAge] = useState<number>(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [isCookieModalVisible, setIsCookieModalVisible] = useState(false);
  // const [isCookiePolicyModalVisible, setIsCookiePolicyModalVisible] =
  //   useState(false);

  const [errorStatus, setErrorStatus] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [AgeEnable, setAgeEnable] = useState(false);

  const [emailEnable, setEmailEnable] = useState(false);
  const [firstEnable, setFirstEnable] = useState(false);
  const [lastEnable, setLastEnable] = useState(false);
  const [passEnable, setPassEnable] = useState(false);
  //   const [firebaseUser, setFirebaseUser] = useState<firebaseUserType>();
  const [firebaseUser, setFirebaseUser] = useState<firebaseUserType>();
  const [firebaseUserProvider, setFirebaseUserProvider] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [dayValue, setDayValue] = useState<any>(null);
  const [monthValue, setMonthValue] = useState<any>(null);
  const [yearValue, setYearValue] = useState<any>(null);
  const [apiErrorMessage, setApiErrorMessage] = useState<string>('');
  const [isQuestionModalVisible, setIsQuestionModalVisible] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const navigate = useNavigate();
  const [user, setUser] = useState<any>();
  const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [documentUrls, setDocumentUrls] = useState<{
    privacyPolicy: string | null;
    termsAndConditions: string | null;
  }>({
    privacyPolicy: null,
    termsAndConditions: null
  });

  const fetchPages = async () => {
    try {
      const storageRef = await ref(storage, 'pages');
      const result = await listAll(storageRef);
      const urls = await Promise.all(
        result.items.map((pages) => getDownloadURL(pages))
      );
  
      setDocumentUrls({
        termsAndConditions: urls[2] || null,
        privacyPolicy: urls[1] || null
      });
    } catch (e) {
      RemoteErrorLog(e, 'SignUp.tsx');
    }
  };
  
  useEffect(() => {
    fetchPages();
  }, []);

  const handlePolicyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (documentUrls.privacyPolicy) {
      setPrivacyPolicyOpen(true);
    } else {
      console.error('Privacy Policy document not available');
    }
  };
  
  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (documentUrls.termsAndConditions) {
      setTermsOpen(true);
    } else {
      console.error('Terms & Conditions document not available');
    }
  };

  const convertToDateString = (
    month: { label: string; value: number },
    day: { label: string; value: number },
    year: { label: string; value: number }
  ): string => {
    const yearValue = year?.value;
    const monthValue = month?.value?.toString().padStart(2, '0');
    const dayValue = day?.value?.toString().padStart(2, '0');
    return `${yearValue}-${monthValue}-${dayValue}`;
  };
  const [signupType, setSignupType] = useState<'teacher' | 'email'>('teacher');

  useEffect(() => {
    if (!validateDate) {
      const dob = convertToDateString(month, day, year);
      setUserDob(dob);
    }
  }, [validateDate]);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authen, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (state?.createPassword) {
      setDayValue(state?.day.value);
      setMonthValue(state?.month.value);
      setYearValue(state?.year.value);
      setIsChecked(state?.isChecked);
      handleDateChange(state?.month, state?.day, state?.year);
      handleFirstName(state?.firstName);
      handleLastName(state?.lastName);
      setCreatePassword(state?.createPassword);
      validatePassword(state?.createPassword);
    }
  }, [state]);

  const validateEmail = (input: string) => {
    setEmail(input);
    if (!input) {
      setErrorStatus('Email is required.');
      setEmailEnable(false);
      return;
    }
    if (validator.isEmail(input)) {
      setEmailEnable(true);
      setErrorStatus('');
    } else {
      setEmailEnable(false);
      setErrorStatus('Please enter a valid email address.');
    }
  };
  const validatePassword = (text: string) => {
    if (text.length < 6) {
      setErrorMessage('The password must be at least 6 characters long.');
      setPassEnable(false);
    } else {
      setPassEnable(true);
      setErrorMessage('');
    }
  };

  const handleDateChange = (
    selectedMonth: any,
    selectedDay: any,
    selectedYear: any
  ) => {
    if (
      isValidDate(selectedMonth.value, selectedDay.value, selectedYear.value)
    ) {
      setValidateDate(false);
      const agee = calculateAge(
        selectedMonth.value,
        selectedDay.value,
        selectedYear.value
      );
      if (agee >= 0) {
        setAge(agee);
        setAgeEnable(true);
      } else {
        setValidateDate(true);
        setAgeEnable(false);
      }
    } else {
      setValidateDate(true);
    }
    setMonth(selectedMonth);
    setDay(selectedDay);
    setYear(selectedYear);
  };

  const handleFirstName = (inputText: string) => {
    setFirstName(inputText);
    if (!inputText.trim()) {
      setFirstEnable(false);
    } else {
      setFirstEnable(true);
    }
  };
  const handleLastName = (inputText1: string) => {
    setLastName(inputText1);
    if (!inputText1.trim()) {
      setLastEnable(false);
    } else {
      setLastEnable(true);
    }
  };

  // const cookieModalOpen = () => {
  //   setIsLoading(false);
  //   setIsCookieModalVisible(!isCookieModalVisible);
  //   //   hideCookieModal();
  // };

  const hideNoQuestionModal = () => {
    setIsQuestionModalVisible(false);
  };

  useEffect(() => {
    if (firebaseUser) {
      // cookieModalOpen();
      hideCookieModal();
    }
  }, [firebaseUser]);

  const cookieApiCall = async (cookieInfo: any) => {
    const token = await (authen?.currentUser as any).getIdToken(true);

    const result = await cookiePreferencesWebsite(
      cookieInfo,
      token,
      environment?.apiUrl
    );

    return result;
  };
  // const openCookiePolicyModal = () => {
  //   setIsCookieModalVisible(false);
  //   setIsCookiePolicyModalVisible(true);
  // };

  // const onSavePreference = () => {
  //   setIsCookiePolicyModalVisible(false);
  //   if (firebaseUserProvider !== 'google.com') {

  //     if (age > 13.002) {
  //       setIsModalVisible(true);
  //     } else {
  //       navigate('/email-verify', {
  //         state: {
  //           email: email,
  //           isChecked: isChecked,
  //           firstName: firstName,
  //           lastName: lastName,
  //           uid: firebaseUser?.uid,
  //           createPassword: createPassword,
  //           month: month,
  //           day: day,
  //           year: year,
  //         },
  //       });
  //       // navigate('VerifyEmailScreen', {
  //       //   email,
  //       //   createPassword,
  //       //   firstName,
  //       //   lastName,
  //       // });
  //     }
  //   } else {
  //     navigate('/home');
  //   }
  // };

  const hideCookieModal = async () => {
    // setIsCookieModalVisible(false);
    // setIsCookiePolicyModalVisible(false);
    const dob = convertToDateString(month, day, year);
    const cookieInfo = {
      uid: firebaseUser?.uid,
      full_name: firebaseUser?.displayName,
      is_anonymous: firebaseUser?.isAnonymous,
      dob:
        firebaseUserProvider == 'google.com' ||
        firebaseUserProvider == 'apple.com'
          ? null
          : dob,
    };
    let apiResult: any;
    if (cookieInfo.uid) {
      apiResult = await cookieApiCall(cookieInfo);
    }
    if (
      firebaseUserProvider !== 'google.com' &&
      firebaseUserProvider !== 'apple.com'
    ) {
      if (age > 13.002) {
        if (apiResult == 'Error') {
          setIsQuestionModalVisible(true);
          setApiErrorMessage(
            'We’re currently experiencing some issues. Please try again later.'
          );
          setIsLoading(false);
        } else {
          setIsModalVisible(true);
          setIsLoading(false);
        }

        setIsLoading(false);
      } else {
        if (apiResult == 'Error') {
          setIsQuestionModalVisible(true);
          setApiErrorMessage(
            'We’re currently experiencing some issues. Please try again later.'
          );
          setIsLoading(false);
        } else {
          navigate('/email-verify', {
            state: {
              email: email,
              isChecked: isChecked,
              firstName: firstName,
              lastName: lastName,
              uid: firebaseUser?.uid,
              createPassword: createPassword,
              month: month,
              day: day,
              year: year,
            },
          });
        }
      }
    } else {
      if (apiResult == 'Error') {
        setIsQuestionModalVisible(true);
        setApiErrorMessage(
          'We’re currently experiencing some issues. Please try again later.'
        );
        setIsLoading(false);
        localStorage.removeItem('userData');
      } else {
        navigate('/home');
      }
    }
  };

  const upgradeToEmailPassword = async (email: string, password: string) => {
    try {
      const credential = EmailAuthProvider.credential(email, password);
      linkWithCredential(authen.currentUser!, credential)
        .then((usercred) => {
          if (usercred.user) {
            updateProfile(usercred.user, {
              displayName: `${firstName} ${lastName}`,
            })
              .then(async () => {
                const dob = convertToDateString(month, day, year);

                const updateProfileType = {
                  uid: authen?.currentUser?.uid ? authen?.currentUser?.uid : '',
                  full_name: `${firstName} ${lastName}`,
                  dob: dob,
                };
                await updateUserProfile(updateProfileType, environment?.apiUrl);
              })
              .then(async () => {
                if (age > 13.002) {
                  await sendEmailVerification(usercred.user);
                  const { uid, isAnonymous, displayName } = usercred.user;
                  const userCookiePrefernce = await fetchCookieUsers(uid);
                  // if (userCookiePrefernce !== true) {
                  //   setFirebaseUser({ uid, isAnonymous, displayName } as any);
                  // } else {
                  if (userCookiePrefernce === 'Error') {
                    setIsQuestionModalVisible(true);
                    setApiErrorMessage(
                      'We’re currently experiencing some issues. Please try again later.'
                    );
                    setIsLoading(false);
                  } else if (userCookiePrefernce === false) {
                    setFirebaseUser({ uid, isAnonymous, displayName } as any);
                  } else {
                    setIsLoading(false);
                    setIsModalVisible(!isModalVisible);
                  }
                  // setIsLoading(false);
                  // setIsModalVisible(true);
                  // }
                } else {
                  const { uid, isAnonymous, displayName } = usercred.user;
                  const userInfo = {
                    email_type: 'coppa',
                    recipient_email: `${email}`,
                    recipient_full_name: `${firstName} ${lastName}`,
                    is_fb_deep_link: false,
                    continue_url: `${environment?.baseUrl}verify-user/${uid}`,
                  };
                  const token = await (authen?.currentUser as any).getIdToken(
                    true
                  );

                  const result = await sendCoppaEmail(
                    userInfo,
                    token,
                    environment?.apiUrl
                  );
                  if (result == 'Error') {
                    setIsQuestionModalVisible(true);
                    setApiErrorMessage(
                      'We’re currently experiencing some issues. Please try again later.'
                    );
                    setIsLoading(false);
                  } else if (!result?.error_message) {
                    const { uid, isAnonymous, displayName } = usercred.user;
                    const userCookiePrefernce = await fetchCookieUsers(uid);
                    if (userCookiePrefernce !== true) {
                      setFirebaseUser({ uid, isAnonymous, displayName } as any);
                    } else {
                      setIsLoading(false);

                      navigate('/email-verify', {
                        state: {
                          email: email,
                          isChecked: isChecked,
                          firstName: firstName,
                          lastName: lastName,
                          uid: uid,
                          createPassword: createPassword,
                          month: month,
                          day: day,
                          year: year,
                        },
                      });
                    }
                  } else {
                    setApiErrorMessage(result?.error_message);
                    setIsQuestionModalVisible(true);
                    setIsLoading(false);
                  }
                }
              })
              .catch((error) => {
                RemoteErrorLog(error, 'SignUp.tsx');
              });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setAlertSeverity('error');
          setAlertMessage(
            'Oops! There’s already an account linked to this email address. Please try signing up with a different email ID.'
          );
          setAlertOpen(true);
          RemoteErrorLog(error, 'SignUp.tsx');
        });
    } catch (error) {
      if (error === 'auth/email-already-in-use') {
        setAlertSeverity('error');
        setAlertMessage('Email address is already in use!');
        setAlertOpen(true);
      }
      RemoteErrorLog(error, 'SignUp.tsx');
    }
  };

  const handleSignUpClick = (type = '') => {
    try {
      if (window.grecaptcha) {
        window.grecaptcha.enterprise.ready(async () => {
          const token = await window.grecaptcha.enterprise.execute(
            environment?.recaptchaSiteKey,
            { action: 'SIGNUP' }
          );

          // Verify the token using the Google API
          const verificationUrl = `https://recaptchaenterprise.googleapis.com/v1/projects/${environment?.firebase?.projectId}/assessments?key=${environment?.firebase?.apiKey}`;

          const response = await fetch(verificationUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              event: {
                token: token,
                siteKey: environment?.recaptchaSiteKey,
                expectedAction: 'SIGNUP',
              },
            }),
          });

          const result = await response.json();

          if (result?.tokenProperties?.valid) {
            if (type === 'google') {
              signInWithGoogle();
            } else if (type === 'apple') {
              signInWithApple();
            } else {
              signUpNewUser();
            }
          } else {
            alert(
              'reCAPTCHA verification failed: ' +
                result?.tokenProperties?.invalidReason
            );
          }
        });
      }
    } catch (error) {
      alert('Failed to verify reCAPTCHA. Please try again later.');
      RemoteErrorLog(error, 'SignUp.tsx');
    }
  };
  const signUpNewUser = async () => {
    setIsLoading(true);

    if (user?.uid && user?.isAnonymous) {
      upgradeToEmailPassword(email, createPassword);
    } else {
      try {
        createUserWithEmailAndPassword(authen, email, createPassword)
          .then((userCredentials) => {
            if (userCredentials.user) {
              updateProfile(userCredentials.user, {
                displayName: `${firstName} ${lastName}`,
              })
                .then(async () => {
                  if (age > 13.002) {
                    await sendEmailVerification(userCredentials.user);
                    const { uid, isAnonymous, displayName } =
                      userCredentials.user;
                    setFirebaseUser({ uid, isAnonymous, displayName } as any);
                  } else {
                    const { uid, isAnonymous, displayName } =
                      userCredentials.user;

                    const userInfo = {
                      email_type: 'coppa',
                      recipient_email: `${email}`,
                      recipient_full_name: `${firstName} ${lastName}`,
                      is_fb_deep_link: false,
                      continue_url: `${environment?.baseUrl}verify-user/${uid}`,
                    };
                    const token = await (authen?.currentUser as any).getIdToken(
                      true
                    );
                    const result = await sendCoppaEmail(
                      userInfo,
                      token,
                      environment?.apiUrl
                    );
                    if (result == 'Error') {
                      setIsQuestionModalVisible(true);
                      setApiErrorMessage(
                        'We’re currently experiencing some issues. Please try again later.'
                      );
                      setIsLoading(false);
                    } else if (!result?.error_message) {
                      const { uid, isAnonymous, displayName } =
                        userCredentials.user;
                      setFirebaseUser({ uid, isAnonymous, displayName } as any);
                    } else {
                      setApiErrorMessage(result?.error_message);
                      setIsQuestionModalVisible(true);
                    }
                  }
                })
                .catch((error) => {
                  RemoteErrorLog(error, 'SignUp.tsx');
                });
            }
          })
          .catch((error) => {
            setIsLoading(false);

            setAlertSeverity('error');
            setAlertMessage(
              'Oops! There’s already an account linked to this email address. Please try signing up with a different email ID.'
            );
            setAlertOpen(true);
            RemoteErrorLog(error, 'SignUp.tsx');
          });
      } catch (error) {
        if (error === 'auth/email-already-in-use') {
          setAlertSeverity('error');
          setAlertMessage('Email address is already in use!');
          setAlertOpen(true);
        }
        RemoteErrorLog(error, 'SignUp.tsx');
      }
    }
  };

  const signInWithGoogle = async () => {
    if (user?.uid && user?.isAnonymous) {
      try {
        const result = await linkWithPopup(user, provider);

        setIsLoading(true);

        await updateProfile(result.user, {
          displayName: `${result.user.providerData[0].displayName}`,
        });
        await user.reload();

        // Get the updated user profile
        const updatedUser = authen.currentUser;
        const updateProfileType = {
          uid: authen?.currentUser?.uid ? authen?.currentUser?.uid : '',
          full_name: `${result.user.providerData[0].displayName}`,
        };
        await updateUserProfile(updateProfileType, environment?.apiUrl);
        localStorage.setItem('userData', JSON.stringify(updatedUser));
        const { uid, isAnonymous, displayName } = updatedUser!;
        const userCookiePrefernce = await fetchCookieUsers(uid);
        if (userCookiePrefernce !== true) {
          setFirebaseUser({ uid, isAnonymous, displayName } as any);
        } else {
          setIsLoading(false);

          navigate('/home');
        }
        setFirebaseUserProvider((await result).user.providerData[0].providerId);
      } catch (error: any) {
        if (error?.code === 'auth/credential-already-in-use') {
          // window.alert('Email already exists');
          setAlertSeverity('error');
          setAlertMessage('Email address is already in use!');
          setAlertOpen(true);
        }
        RemoteErrorLog(error, 'SignUp.tsx');
      }
    } else {
      try {
        const result = await signInWithPopup(authen, provider);
        const googleCredentials =
          GoogleAuthProvider.credentialFromResult(result);

        const userInfo = signInWithCredential(authen, googleCredentials!);
        setIsLoading(true);
        localStorage.setItem('userData', JSON.stringify((await userInfo).user));
        const { uid, isAnonymous, displayName } = (await userInfo).user;
        const userCookiePrefernce = await fetchCookieUsers(uid);
        if (userCookiePrefernce !== true) {
          setFirebaseUser({ uid, isAnonymous, displayName } as any);
        } else {
          setIsLoading(false);
          navigate('/home');
        }
        setFirebaseUserProvider(
          (await userInfo).user.providerData[0].providerId
        );
      } catch (error) {
        RemoteErrorLog(error, 'SignUp.tsx');
      }
    }
  };
  const signInWithApple = async () => {
    if (user?.uid && user?.isAnonymous) {
      try {
        providerApple.addScope('email');
        providerApple.addScope('name');
        const result = await linkWithPopup(user, providerApple);
        setIsLoading(true);

        await updateProfile(result.user, {
          displayName: `${result.user.providerData[0].displayName}`,
        });
        await user.reload();

        // Get the updated user profile
        const updatedUser = authen.currentUser;
        const updateProfileType = {
          uid: authen?.currentUser?.uid ? authen?.currentUser?.uid : '',
          full_name: `${result.user.providerData[0].displayName}`,
        };
        await updateUserProfile(updateProfileType, environment?.apiUrl);
        localStorage.setItem('userData', JSON.stringify(updatedUser));
        const { uid, isAnonymous, displayName } = updatedUser!;
        const userCookiePrefernce = await fetchCookieUsers(uid);
        if (userCookiePrefernce !== true) {
          setFirebaseUser({ uid, isAnonymous, displayName } as any);
        } else {
          setIsLoading(false);

          navigate('/home');
        }
        setFirebaseUserProvider((await result).user.providerData[0].providerId);
      } catch (error: any) {
        if (error?.code === 'auth/credential-already-in-use') {
          // window.alert('Email already exists');
          setAlertSeverity('error');
          setAlertMessage('Email address is already in use!');
          setAlertOpen(true);
        }
        RemoteErrorLog(error, 'SignUp.tsx');
      }
    } else {
      try {
        providerApple.addScope('email');
        providerApple.addScope('name');
        const result = await signInWithPopup(authen, providerApple);
        // const googleCredentials =
        //   GoogleAuthProvider.credentialFromResult(result);
        const credential = OAuthProvider.credentialFromResult(result);
        const userInfo = signInWithCredential(authen, credential!);

        setIsLoading(true);
        localStorage.setItem('userData', JSON.stringify((await userInfo).user));
        const { uid, isAnonymous, displayName } = (await userInfo).user;
        const userCookiePrefernce = await fetchCookieUsers(uid);
        if (userCookiePrefernce !== true) {
          setFirebaseUser({ uid, isAnonymous, displayName } as any);
        } else {
          setIsLoading(false);
          navigate('/home');
        }
        setFirebaseUserProvider(
          (await userInfo).user.providerData[0].providerId
        );
      } catch (error) {
        RemoteErrorLog(error, 'SignUp.tsx');
      }
    }
  };

  const handleCleverSignup = async () => {
    try {
      const auth = getAuth();
      await setPersistence(auth, browserSessionPersistence);
      const width = 500;
      const height = 600;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;
  
      const popup = window.open(
        'about:blank',
        'Clever Signup',
        `width=${width},height=${height},left=${left},top=${top}`
      );
  
      if (!popup) {
        throw new Error('Popup blocked. Please enable popups and try again.');
      }
  
      const response = await axios.get(`${environment.backendUrl}oauth/authorize`);
      popup.location.replace(response.data.login_url);
  
      const userInfo = await new Promise<{ 
        user: any, 
        first_login: boolean, 
        spelling_preference_set: boolean 
      }>((resolve, reject) => {
        const popupCheckInterval = setInterval(() => {
          if (popup.closed) {
            clearInterval(popupCheckInterval);
            window.removeEventListener('message', handleMessage);
            reject(new Error('Signup cancelled'));
          }
        }, 500);
  
        const handleMessage = async (event: MessageEvent) => {
          if (event.data.error) {
            clearInterval(popupCheckInterval);
            reject(new Error(event.data.message || 'Error during Clever signup'));
            return;
          }
  
          if (event.data.token && event.data.user_id) {
            try {
              clearInterval(popupCheckInterval);
              const credential = await signInWithCustomToken(auth, event.data.token);
              resolve({ 
                user: credential.user, 
                first_login: event.data.first_login, 
                spelling_preference_set: event.data.spelling_preference_set 
              });
            } catch (error) {
              reject(error);
            } finally {
              popup.close();
              window.removeEventListener('message', handleMessage);
            }
          }
        };
  
        window.addEventListener('message', handleMessage);
  
        setTimeout(() => {
          clearInterval(popupCheckInterval);
          window.removeEventListener('message', handleMessage);
          popup.close();
          reject(new Error('Signup timed out. Please try again.'));
        }, 60000);
      });
  
      localStorage.setItem('userData', JSON.stringify(userInfo.user));
      const { uid, isAnonymous, displayName } = userInfo.user;
  
      const userCookiePreference = await fetchCookieUsers(uid);
      if (userCookiePreference === 'Error') {
        setIsQuestionModalVisible(true);
        setApiErrorMessage(
          "We're currently experiencing some issues. Please try again later."
        );
        localStorage.removeItem('userData');
      } else if (userCookiePreference === false) {
        setFirebaseUser({ uid, isAnonymous, displayName });
      } else if (userInfo.first_login || !userInfo.spelling_preference_set) {
        navigate('/home', { state: { showSpellingPrefModal: true } });
      } else {
        navigate('/home');
      }
  
      setFirebaseUserProvider('clever.com');
  
    } catch (error: any) {
      if (error.message === 'Signup cancelled') {
        return;
      }
      
      RemoteErrorLog(error, 'SignUp.tsx');
      if (error.message.includes("Your Clever account does not exist")) {
        setIsQuestionModalVisible(true);
        setApiErrorMessage(error.message);
      } else if (error.message === 'Signup timed out. Please try again.') {
        window.alert(error.message);
      } else {
        window.alert('Failed to authenticate with Clever. Please try again.');
      }
    }
  };
  
  const handleClasslinkSignup = async () => {
    try {
      const auth = getAuth();
      await setPersistence(auth, browserSessionPersistence);
      const width = 500;
      const height = 600;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;
  
      const popup = window.open(
        'about:blank',
        'ClassLink Signup',
        `width=${width},height=${height},left=${left},top=${top}`
      );
  
      if (!popup) {
        throw new Error('Popup blocked. Please enable popups and try again.');
      }
  
      const response = await axios.get(`${environment.backendUrl}classlink/authorize`);
      popup.location.replace(response.data.login_url);
  
      const userInfo = await new Promise<{ 
        user: any,
        first_login: boolean,
        spelling_preference_set: boolean 
      }>((resolve, reject) => {
        const popupCheckInterval = setInterval(() => {
          if (popup.closed) {
            clearInterval(popupCheckInterval);
            window.removeEventListener('message', handleMessage);
            reject(new Error('Signup cancelled'));
          }
        }, 500);
  
        const handleMessage = async (event: MessageEvent) => {
          if (event.data.error) {
            clearInterval(popupCheckInterval);
            reject(new Error(event.data.message || 'Error during ClassLink signup'));
            return;
          }
  
          if (event.data.token && event.data.user_id) {
            try {
              clearInterval(popupCheckInterval);
              const credential = await signInWithCustomToken(auth, event.data.token);
              resolve({ 
                user: credential.user,
                first_login: event.data.first_login,
                spelling_preference_set: event.data.spelling_preference_set 
              });
            } catch (error) {
              reject(error);
            } finally {
              popup.close();
              window.removeEventListener('message', handleMessage);
            }
          }
        };
  
        window.addEventListener('message', handleMessage);
  
        setTimeout(() => {
          clearInterval(popupCheckInterval);
          window.removeEventListener('message', handleMessage);
          popup.close();
          reject(new Error('Signup timed out. Please try again.'));
        }, 60000);
      });
  
      localStorage.setItem('userData', JSON.stringify(userInfo.user));
      const { uid, isAnonymous, displayName } = userInfo.user;
  
      const userCookiePreference = await fetchCookieUsers(uid);
      if (userCookiePreference === 'Error') {
        setIsQuestionModalVisible(true);
        setApiErrorMessage(
          "We're currently experiencing some issues. Please try again later."
        );
        localStorage.removeItem('userData');
      } else if (userCookiePreference === false) {
        setFirebaseUser({ uid, isAnonymous, displayName });
      } else if (userInfo.first_login || !userInfo.spelling_preference_set) {
        navigate('/home', { state: { showSpellingPrefModal: true } });
      } else {
        navigate('/home');
      }
  
      setFirebaseUserProvider('classlink.com');
  
    } catch (error: any) {
      if (error.message === 'Signup cancelled') {
        return;
      }
      RemoteErrorLog(error, 'SignUp.tsx');
      if (error.message.includes("Your ClassLink account does not exist")) {
        setIsQuestionModalVisible(true);
        setApiErrorMessage(error.message);
      } else if (error.message === 'Signup timed out. Please try again.') {
        window.alert(error.message);
      } else {
        window.alert('Failed to authenticate with ClassLink. Please try again.');
      }
    }
  };

  const handleClose = (event: any, reason: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
  };

  const hideModal = () => {
    setIsModalVisible(!isModalVisible);
    navigate('/login');
  };

  const loadReCaptchaScript = (siteKey: string) => {
    return new Promise<void>((resolve, reject) => {
      if (
        document.querySelector(
          `script[src="https://www.google.com/recaptcha/enterprise.js?render=${siteKey}"]`
        )
      ) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () =>
        reject(new Error('Failed to load reCAPTCHA script'));
      document.head.appendChild(script);
    });
  };

  const removeReCaptchaScript = (siteKey: string) => {
    const script = document.querySelector(
      `script[src="https://www.google.com/recaptcha/enterprise.js?render=${siteKey}"]`
    );
    if (script) {
      document.head.removeChild(script);
    }
  };
  useEffect(() => {
    const loadScript = async () => {
      try {
        await loadReCaptchaScript(environment?.recaptchaSiteKey);
      } catch (error) {
        RemoteErrorLog(error, 'SignUp.tsx');
      }
    };

    loadScript();

    return () => {
      removeReCaptchaScript(environment?.recaptchaSiteKey);
    };
  }, []);

  const formContent = (
    <section className="quiz-signup">
      <Box sx={{ padding: 0, width: '100%' }}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            {isLoading ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100vh',
                }}
              >
                <CircularProgress
                  size={56}
                  sx={{
                    color: 'primary.main',
                  }}
                />
              </Box>
            ) : (
              <Box
                className="form-container"
                sx={{
                  width: '100%',
                  maxWidth: 'none',
                  padding: 0,
                  marginTop: 0,
                }}
              >
                <Box>
                  <form style={{ paddingTop: 0, marginTop: 0 }}>
                    <FormControl component="fieldset" sx={{ mb: 2, mt: 2, pt: 0 }}>
                      <RadioGroup
                        row
                        value={signupType}
                        onChange={(e) => setSignupType(e.target.value as 'teacher' | 'email')}
                        sx={{
                          gap: 2,
                          mt: 0,
                          pt: 0
                        }}
                      >
                        <FormControlLabel
                          value="teacher"
                          control={
                            <Radio
                              sx={{
                                '&.Mui-checked': {
                                  color: 'green',
                                },
                                '& .MuiTouchRipple-root': {
                                  color: 'green',
                                }
                              }}
                            />
                          }
                          label="Teacher / Administrator"
                        />
                        <FormControlLabel
                          value="email"
                          control={
                            <Radio
                              sx={{
                                '&.Mui-checked': {
                                  color: 'green',
                                },
                                '& .MuiTouchRipple-root': {
                                  color: 'green',
                                }
                              }}
                            />
                          }
                          label="Email"
                        />
                      </RadioGroup>
                    </FormControl>

                    {signupType === 'teacher' ? (
                      <Grid container spacing={2}>
                        <Grid item md={10} sx={{ margin: 'auto' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) => setIsChecked(e.target.checked)}
                                name=""
                                checked={isChecked}
                              />
                            }
                            sx={{ paddingBottom: '40px' }}
                            label={
                              <Typography variant="body2">
                                By clicking here, I agree to the{' '}
                                <Link 
                                  to="#" 
                                  onClick={handlePolicyClick}
                                >
                                  Privacy Policy
                                </Link> and{' '}
                                <Link 
                                  to="#" 
                                  onClick={handleTermsClick}
                                >
                                  Terms & Conditions
                                </Link>.
                              </Typography>
                            }
                          />
                          <Button
                            variant="outlined"
                            className="btn btn-member btn-outline-secondary"
                            sx={{
                              textTransform: 'none',
                              marginBottom: '20px'
                            }}
                            onClick={handleCleverSignup}
                            fullWidth
                            disabled={!isChecked}
                            startIcon={
                              <img
                                src={cleverIcon}
                                alt="clever icon"
                                className="icon-offset"
                              />
                            }
                          >
                            Sign up with Clever
                          </Button>
                          <Button
                            variant="outlined"
                            className="btn btn-member btn-outline-secondary"
                            sx={{
                              textTransform: 'none',
                            }}
                            onClick={handleClasslinkSignup}
                            fullWidth
                            disabled={!isChecked}
                            startIcon={
                              <img
                                src={classlinkIcon}
                                alt="classlink icon"
                                className="icon-offset"
                              />
                            }
                          >
                            Sign up with ClassLink
                          </Button>
                          <Button
                            variant="outlined"
                            className="btn btn-member btn-outline-secondary"
                            sx={{
                              textTransform: 'none',
                              marginTop: '20px'
                            }}
                            onClick={() => {
                              window.open('/register-school', '_blank', 'noopener,noreferrer');
                            }}
                            fullWidth
                            disabled={!isChecked}
                            startIcon={
                              <img
                                src={schoolIcon}
                                alt="school icon"
                                className="icon-offset"
                              />
                            }
                          >
                            Sign up with Indian School
                          </Button>
                        </Grid>
                      </Grid>
                    ) : (
                    <form>
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        className="mb-3 signup-flex-basis-remove"
                      >
                        <Grid item md={4} sx={{ flexBasis: '33%' }}>
                          <Typography
                            variant="body1"
                            component="label"
                            className="font-600"
                          >
                            Your birth date*
                          </Typography>
                        </Grid>
                        <Grid item md={8} sx={{ flexBasis: '67%' }}>
                          <Grid container spacing={2}>
                            <Grid item xs={4}>
                              <Select
                                placeholder="Month"
                                options={monthsOfYear}
                                value={month}
                                onChange={(selectedMonth) => {
                                  setMonthValue(selectedMonth?.value);
                                  handleDateChange(selectedMonth, day, year);
                                }}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Select
                                placeholder="Day"
                                options={daysOfMonth}
                                value={day}
                                onChange={(selectedDay) => {
                                  setDayValue(selectedDay?.value);
                                  handleDateChange(month, selectedDay, year);
                                }}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Select
                                placeholder="Year"
                                options={calenderYears}
                                value={year}
                                onChange={(selectedYear) => {
                                  setYearValue(selectedYear?.value);
                                  handleDateChange(month, day, selectedYear);
                                }}
                              />
                            </Grid>
                          </Grid>
                          {validateDate === true && (
                            <div style={{ color: 'red' }}>
                              Please enter a valid date
                            </div>
                          )}
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        className="mb-3 signup-flex-basis-remove"
                      >
                        <Grid item md={4} sx={{ flexBasis: '33%' }}>
                          <Typography
                            variant="body1"
                            className="font-600"
                            component="label"
                          >
                            {age > 13.002
                              ? 'Your email*'
                              : 'Your parent email*'}
                          </Typography>
                        </Grid>
                        <Grid item md={8} sx={{ flexBasis: '67%' }}>
                          <TextField
                            fullWidth
                            type="email"
                            placeholder="example@email.com"
                            variant="outlined"
                            value={email}
                            onChange={(e) => validateEmail(e.target.value)}
                          />
                          {errorStatus && (
                            <div style={{ color: 'red' }}>{errorStatus}</div>
                          )}
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        className="mb-3 signup-flex-basis-remove"
                      >
                        <Grid item md={4} sx={{ flexBasis: '33%' }}>
                          <Typography
                            variant="body1"
                            className="font-600"
                            component="label"
                          >
                            First name*
                          </Typography>
                        </Grid>
                        <Grid item md={8} sx={{ flexBasis: '67%' }}>
                          <TextField
                            fullWidth
                            type="text"
                            variant="outlined"
                            value={firstName}
                            onChange={(e) => handleFirstName(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        className="mb-3 signup-flex-basis-remove"
                      >
                        <Grid item md={4} sx={{ flexBasis: '33%' }}>
                          <Typography
                            variant="body1"
                            className="font-600"
                            component="label"
                          >
                            Last name*
                          </Typography>
                        </Grid>
                        <Grid item md={8} sx={{ flexBasis: '67%' }}>
                          <TextField
                            fullWidth
                            type="text"
                            variant="outlined"
                            value={lastName}
                            onChange={(e) => handleLastName(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        className="mb-3 signup-flex-basis-remove"
                      >
                        <Grid item md={4} sx={{ flexBasis: '33%' }}>
                          <Typography
                            variant="body1"
                            className="font-600"
                            component="label"
                          >
                            Create a password*
                            <Typography variant="caption" component="p">
                              {' '}
                              {age < 13.002 &&
                                '(We will email this to your parent)'}
                            </Typography>
                          </Typography>
                        </Grid>
                        <Grid item md={8} sx={{ flexBasis: '67%' }}>
                          <TextField
                            fullWidth
                            type="password"
                            placeholder="Please enter at least 6 characters."
                            variant="outlined"
                            value={createPassword}
                            onChange={(e) => {
                              setCreatePassword(e.target.value);
                              validatePassword(e.target.value);
                            }}
                          />
                          {errorMessage ? (
                            <div style={{ color: 'red' }}>{errorMessage}</div>
                          ) : null}
                        </Grid>
                      </Grid>

                      <Grid container spacing={2}>
                        <Grid item md={10} sx={{ margin: 'auto' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) => setIsChecked(e.target.checked)}
                                name=""
                                checked={isChecked}
                              />
                            }
                            sx={{ paddingBottom: '40px' }}
                            label={
                              <Typography variant="body2">
                                By clicking here, I agree to the{' '}
                                <Link to="#">Privacy Policy</Link> and{' '}
                                <Link to="#">Terms & Conditions</Link>.
                              </Typography>
                            }
                          />
                          {/* <Link to="/email-verify"> */}
                          <Button
                            variant="contained"
                            disabled={
                              !(
                                AgeEnable &&
                                emailEnable &&
                                passEnable &&
                                firstEnable &&
                                lastEnable &&
                                isChecked &&
                                !validateDate
                              )
                            }
                            onClick={() => handleSignUpClick('')}
                            className="btn btn-primary btn-member"
                            sx={{ textTransform: 'none' }}
                            fullWidth
                            startIcon={
                              <img
                                src={mailicon}
                                alt="mail icon"
                                className="icon-offset"
                              />
                            }
                          >
                            Sign up
                          </Button>

                          {(age === 0 || age > 13.002) && (
                            <>
                              <Box className="seperator">
                                <span>OR</span>
                              </Box>
                              <Button
                                variant="outlined"
                                className="btn btn-member btn-outline-secondary "
                                sx={{ textTransform: 'none' }}
                                onClick={() => handleSignUpClick('google')}
                                fullWidth
                                startIcon={
                                  <img
                                    src={googleicon}
                                    alt="google icon"
                                    className="icon-offset"
                                  />
                                }
                              >
                                Sign up with Google
                              </Button>
                              <Button
                                variant="outlined"
                                className="btn btn-member btn-outline-secondary "
                                sx={{
                                  textTransform: 'none',
                                  marginTop: '20px',
                                }}
                                onClick={() => handleSignUpClick('apple')}
                                fullWidth
                                startIcon={
                                  <img
                                    src={appleicon}
                                    alt="google icon"
                                    className="icon-offset"
                                  />
                                }
                              >
                                Sign up with Apple
                              </Button>
                            </>
                          )}
                          <Typography
                            variant="body1"
                            sx={{ textTransform: 'none' }}
                            className="text-center mt-3 font-600"
                          >
                            Already have an account?{' '}
                            <Link to="/login">Login</Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    </form>
                    )}
                  </form>
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </section>
  );

  if (isSubComponent) {
    return formContent;
  }

  return (
    <>
      <Helmet>
        <title>
          Sign Up to Learn & Play Spelling Games For Kids - Spelling Hero
        </title>
        <meta
          name="description"
          content="Let's play our fun spelling games app for kids to practice spelling words and learn at a variety of levels. Simply sign up for free to get started!"
        />
        <link rel="canonical" href="https://spellinghero.app/signup"></link>
      </Helmet>
      <header>
        <Navbar currentPage="signup" />
      </header>
      {formContent}
      <CustomModal
        isModalVisible={isModalVisible}
        onPress={hideModal}
        buttonText="OK"
        modalTitle="Verify your Email ID"
        text="Before login, please verify your email address. Click the verification link we've sent to your inbox!"
        icon={true}
      />
      <CustomNoResponseModal
        isModalVisible={isQuestionModalVisible}
        onPress={hideNoQuestionModal}
        buttonText="OK"
        modalTitle="Oops!"
        text={apiErrorMessage}
      />
      <AlertPopup
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        onClose={() => setAlertOpen(false)}
      />
      <DocumentViewerModal
        open={privacyPolicyOpen}
        onClose={() => setPrivacyPolicyOpen(false)}
        documentUrl={documentUrls.privacyPolicy}
        title="Privacy Policy"
      />
      <DocumentViewerModal
        open={termsOpen}
        onClose={() => setTermsOpen(false)}
        documentUrl={documentUrls.termsAndConditions}
        title="Terms & Conditions"
      />
    </>
  );
}
